/**
 * ChatLayout - Main layout with sidebar and content area
 */

import { ReactNode } from 'react'
import clsx from 'clsx'

interface ChatLayoutProps {
  sidebar: ReactNode
  children: ReactNode
  isSidebarCollapsed?: boolean
  onToggleSidebar?: () => void
}

export function ChatLayout({
  sidebar,
  children,
  isSidebarCollapsed = false,
}: ChatLayoutProps) {
  return (
    <div className="flex h-full w-full bg-gray-50 dark:bg-dark-muted">
      {/* Sidebar */}
      <div
        className={clsx(
          'relative flex-shrink-0 transition-all duration-300',
          isSidebarCollapsed ? 'w-14' : 'w-72'
        )}
      >
        {sidebar}
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {children}
      </div>
    </div>
  )
}

export default ChatLayout
